import { useEffect, useState } from 'react'

import ThemeModule from './Module'

import { ITheme } from './types'

export default function useTheme(): ITheme {
  const [theme, setTheme] = useState({ style: ThemeModule.style })

  useEffect(() => ThemeModule.onUpdate(() => void setTheme({ style: ThemeModule.style })), [])

  return theme
}
